/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PriceType } from './PriceType';
import {
    PriceTypeFromJSON,
    PriceTypeFromJSONTyped,
    PriceTypeToJSON,
    PriceTypeToJSONTyped,
} from './PriceType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentVariantRequest
 */
export interface AppointmentVariantRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentVariantRequest
     */
    participantCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof AppointmentVariantRequest
     */
    duration: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentVariantRequest
     */
    slotIntervalMinutes: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof AppointmentVariantRequest
     */
    price: number;
    /**
     * 
     * @type {PriceType}
     * @memberof AppointmentVariantRequest
     */
    priceType: PriceType;
    /**
     * 
     * @type {number}
     * @memberof AppointmentVariantRequest
     */
    payRate: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentVariantRequest
     */
    onlineMeetingUrl: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentVariantRequest
     */
    isActive: boolean;
}



/**
 * Check if a given object implements the AppointmentVariantRequest interface.
 */
export function instanceOfAppointmentVariantRequest(value: object): value is AppointmentVariantRequest {
    if (!('participantCount' in value) || value['participantCount'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('slotIntervalMinutes' in value) || value['slotIntervalMinutes'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('priceType' in value) || value['priceType'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('onlineMeetingUrl' in value) || value['onlineMeetingUrl'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function AppointmentVariantRequestFromJSON(json: any): AppointmentVariantRequest {
    return AppointmentVariantRequestFromJSONTyped(json, false);
}

export function AppointmentVariantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentVariantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'participantCount': ApiUserTasksGetPageParameterFromJSON(json['participantCount']),
        'duration': json['duration'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterFromJSON(json['slotIntervalMinutes']),
        'price': json['price'],
        'priceType': PriceTypeFromJSON(json['priceType']),
        'payRate': json['payRate'],
        'onlineMeetingUrl': json['onlineMeetingUrl'],
        'isActive': json['isActive'],
    };
}

export function AppointmentVariantRequestToJSON(json: any): AppointmentVariantRequest {
    return AppointmentVariantRequestToJSONTyped(json, false);
}

export function AppointmentVariantRequestToJSONTyped(value?: AppointmentVariantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participantCount': ApiUserTasksGetPageParameterToJSON(value['participantCount']),
        'duration': value['duration'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterToJSON(value['slotIntervalMinutes']),
        'price': value['price'],
        'priceType': PriceTypeToJSON(value['priceType']),
        'payRate': value['payRate'],
        'onlineMeetingUrl': value['onlineMeetingUrl'],
        'isActive': value['isActive'],
    };
}

